<template>
  <iframe id="header" :src="getConfig('VUE_APP_CUSTOMER_HEADER_SRC')">
  </iframe>
</template>

<script>

export default {
  methods: {
    getConfig(configKey) {
      return process.env[configKey]
    }
  }
};
</script>

<style>
  #header {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 101%;
  height: 40vh;
  margin: 0;
  border: none;
}

@media (min-width: 1600px) {
  #header {
    height: 28vh;
  }
}

@media (max-width: 1024px) {
  #header {
    height: 22vh;
  }
}

@media (max-width: 789px) {
  #header {
    height: 30vh;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
#header {
    height: 80vh;
}
}
</style>